
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconMinorLateralGreen as ObiSimplifiedBeaconMinorLateralGreenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-minor-lateral-green.js';
 
 
 

 
 export const ObiSimplifiedBeaconMinorLateralGreen = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-minor-lateral-green',
   elementClass: ObiSimplifiedBeaconMinorLateralGreenElement,
   events: {
     
   }
  });
 
 